import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';
import { Progetto } from '../types';

interface BudgetProgressBarProps {
  progetto: Progetto;
}

const BudgetProgressBar: React.FC<BudgetProgressBarProps> = ({ progetto }) => {
  const budgetTotale = progetto.budget_gg_uu || 0;
  const budgetPianificato = progetto.budget_pianificato_gg_uu || 0;

  // Calcola budget disponibile
  const budgetDisponibile = budgetTotale - budgetPianificato;

  // Calcola percentuale di utilizzo
  const utilizzato = budgetPianificato;
  const percentualeUtilizzo = budgetTotale > 0
    ? Math.min((utilizzato / budgetTotale) * 100, 100)
    : 0;

  // Determina il colore in base al budget disponibile
  let coloreBarra: 'success' | 'warning' | 'error' = 'success';
  if (budgetDisponibile < 0) {
    coloreBarra = 'error'; // Rosso - sforamento
  } else if (budgetTotale > 0) {
    const percentualeDisponibile = (budgetDisponibile / budgetTotale) * 100;
    if (percentualeDisponibile <= 20) {
      coloreBarra = 'warning'; // Giallo - attenzione
    }
  }

  // Arrotonda i valori per la visualizzazione
  const formatGiorni = (val: number) => Math.round(val * 10) / 10;

  return (
    <Box sx={{ width: '100%', mt: 1 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
        <Typography variant="caption" color="text.secondary">
          Budget: {formatGiorni(utilizzato)}gg / {formatGiorni(budgetTotale)}gg
        </Typography>
        <Typography
          variant="caption"
          sx={{
            fontWeight: 'bold',
            color: budgetDisponibile < 0 ? 'error.main' : 'text.secondary'
          }}
        >
          Disp: {formatGiorni(budgetDisponibile)}gg
        </Typography>
      </Box>

      <LinearProgress
        variant="determinate"
        value={percentualeUtilizzo}
        color={coloreBarra}
        sx={{
          height: 8,
          borderRadius: 1,
          backgroundColor: 'action.hover'
        }}
      />

    </Box>
  );
};

export default BudgetProgressBar;
